import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Adventures from './pages/Adventures';
import AdventureDetail from './pages/AdventureDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Sightings from './pages/Sightings';

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-mig" element={<About />} />
          <Route path="/eventyr" element={<Adventures />} />
          <Route path="/eventyr/:slug" element={<AdventureDetail />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/spot-otto" element={<Sightings />} />
          <Route path="/observationer" element={<Sightings />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
